import React from "react";
import { Card } from "../common/CardProps";
import GsapMagnetic from "./GsapMagnetic";
// import Parallax from "./Parallax";
import { CardComponentProps } from "../common/types";
import { formatDateToMonthYear } from "../../utils/helperFunctions";


function CardComponent({ ...props }: CardComponentProps) {
  //N/B the className classWidth is for responsive width which is given for highest order element

  return (
    // <Parallax key={props.$projectId} offset={20}>
      <GsapMagnetic key={props.$projectId} $magneticBorderRadius="10px">
        <Card key={props.$projectId} onClick={props.onClick}>
        <img src={props.$imgUrl} alt={props.$text} className="imgContent" />
          <div className="content">
            <span> {  props.$projectName.length > 25? `${ props.$projectName.slice(0, 25) }...` : props.$projectName } </span>
            <span> { formatDateToMonthYear(props.$projectYear) } </span>
          </div>
        </Card>
      </GsapMagnetic>
    // {/* </Parallax> */}
  );
}

export default React.memo(CardComponent);